import React from 'react';
import './CoveragePeriod.css';
import TauriImage from '../../../TauriImage/TauriImage';

const statusIcon = {
  0: "/Images/material-symbols--pending-actions.svg",
  1: "/Images/material-symbols--check.svg",
  2: "/Images/akar-icons--person-cross.svg",
  3: "/Images/mdi--hourglass.svg",
  4: "/Images/mdi--check-decagram.svg",
  5: "/Images/material-symbols--check-advanced.svg"
};

const CoveragePeriod = ({ data }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
  };
  console.log(data)
  return (
    <div className="account-coverage-container">
      {(!data || data.length === 0) ? (
        <div className="no-coverage w-100 d-flex flex-column align-items-center justify-content-center py-4">
          <TauriImage localImage={"/Images/lucide--frown.svg"} alt="icon" />
          <div>No history of coverage yet</div>
        </div>
      ) : (
        data.map((period, idx) => (
          <div key={idx} className="coverage-period">
            <div className="period-header">
              <span className="code">{period?.Cycle?.Code}</span> -{" "}
              <span className="range">{period?.Cycle?.Description}</span>
            </div>

            {period.Session.map((entry, i) => (
              <div key={i} className="entry-row">
                <div className="entry-date">{formatDate(entry.Date)}</div>
                <div className="entry-icon">
                  {entry?.Joint &&
                    <TauriImage
                      localImage="/Images/mdi--handshake-outline.svg"
                      alt={`status-${entry?.Status}`}
                    />
                  }
                  <TauriImage
                    localImage={statusIcon[entry?.Status]}
                    alt={`status-${entry?.Status}`}
                  />
                </div>
                <div className="entry-name">{entry.Account}</div>
              </div>
            ))}
            <div className="account-coverage-separator" />
          </div>
        ))
      )}
    </div>
  );
};

export default CoveragePeriod;
